import {BadWords} from '../assets/data/bad_words.js'

export default function wordCheck(arg, wordsNumber) {

  const emoji = /[\uD800-\uDBFF]|[\u2702-\u27B0]|[\uF680-\uF6C0]|[\u24C2-\uF251]/g
  const num = /^\d+$/g
  //const punti = /[!"#$%&'()*+,\-.\/\:;<=>?@\[\\\]^_‘{|}~£]/g

  const parole = arg.trim().toLowerCase().split(/\s+/)
  // Blocca se più di <wordsNumber>
  if (parole.length > wordsNumber) return false

  for (let parola of parole) {
    if (
        //parola.length < 2 ||
        emoji.test(parola) ||
        //punti.test(parola) ||
        BadWords.includes(parola) ||
        num.test(parola)
    ) {
      return false
    }
  }

  return true
}
